(function () {
  // --- REGISTER PLUGINS ---
  gsap.registerPlugin(ScrollTrigger, ModifiersPlugin);

  // --- FADE IN IMAGES ON SCROLL ---
  const fadeInImages = () => {
    const images = document.querySelectorAll('img.fade-img');
    images.forEach((img) => {
      gsap.fromTo(
        img,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: img,
            start: 'top 90%',
            toggleActions: 'play none none none',
          }
        }
      );
    });
  };

  // --- Instagram Marquee ---
  class InstaMarqueeHandler {
    constructor(e) {
      this.fetchUrl = e;
      this.container = document.getElementById("ig-feed");
      this.fetchUrl ? this._init() : console.error("Behold.io URL is not valid");
    }

    async _init() {
      const e = await this._fetchData(this.fetchUrl);
      if (e && e.posts) {
        this._addSlides(e.posts);
        this._addIconClasses();
        this._cloneSlides();
      }
    }

    async _fetchData(e) {
      try {
        const t = await fetch(e);
        return await t.json();
      } catch (e) {
        console.error(e);
      }
    }

    _addSlides(e) {
      e.forEach(post => this._createSlides(post));
    }

    _videoContent(e, t) {
      return `<a href="${e}" target="_blank" aria-label="View Instagram Post">
        <div class="ig-image-overlay"></div>
        <video autoplay muted loop playsinline name="media" alt="Unwell Instagram Video">
          <source src="${t}" type="video/mp4">
        </video>
      </a>`;
    }

    _imageContent(e, t) {
      return `<a href="${e}" target="_blank" aria-label="View Instagram Post">
        <div class="ig-image-overlay"></div>
        <img src="${t}" width="800" height="auto" alt="Unwell Instagram Post"/> 
      </a>`;
    }

    async _createSlides(e) {
      const t = document.createElement("div");
      t.classList.add("ig-marquee-slide");
      const i = e.mediaType.toLowerCase();
      if (i === "video") t.innerHTML = this._videoContent(e.permalink, e.mediaUrl);
      else if (i === "image") t.innerHTML = this._imageContent(e.permalink, e.mediaUrl);
      else if (i === "carousel_album") {
        const i = e.children[0], o = i.mediaType.toLowerCase();
        if (o === "video") t.innerHTML = this._videoContent(e.permalink, i.mediaUrl);
        else if (o === "image") t.innerHTML = this._imageContent(e.permalink, i.mediaUrl);
      } else {
        console.error(`Media type of "${i}" cannot be displayed in the Instagram feed.`);
      }

      const o = document.createElement("div");
      o.classList.add("ig-marquee-slide-wrapper");
      this._setAspectRatio(o);
      o.appendChild(t);
      this.container.appendChild(o);
    }

    _setAspectRatio(el) {
      const aspectRatios = [1 / 1, 1 / 1.2, 1 / 1.5, 314 / 511];
      const ratio = aspectRatios[Math.floor(Math.random() * aspectRatios.length)];
      el.style.aspectRatio = `${ratio}`;
    }

    async _addIconClasses() {
      const e = [...this.container.querySelectorAll(".ig-marquee-slide-wrapper")];
      const t = Math.floor(e.length / 2);
      const i = [e[0], e[t]];
      if (e.length > 11) {
        e.forEach((el, idx) => {
          if (idx % 4 === 0) el.classList.add("icon-added");
        });
      } else if (e.length > 4) {
        i.forEach(el => el.classList.add("icon-added"));
      } else {
        e[0].classList.add("icon-added");
      }
    }

    _cloneSlides() {
      const e = this.container.innerHTML;
      this.container.innerHTML += e;
    }
  }
  
  // --- TICKER BAR SCROLL ANIMATION ---
  document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('ticker-bar.scroll-triggered').forEach(ticker => {
    const scale = ticker.querySelector('[data-ticker-scale]');
    const loop = scale?.querySelector('.scrolling-loop');
    if (!scale || !loop) return;

    const direction = ticker.getAttribute('data-direction');
    const isLtr = direction === 'ticker-ltr';
    const distance = 80;
    const height = ticker.offsetHeight; // Get the height of the ticker

    gsap.fromTo(
      loop,
      { x: isLtr ? -loop.offsetWidth / 2 : 0 }, 
      {
        x: isLtr ? `+=${distance}` : `-=${distance}`,
        ease: "none",
        scrollTrigger: {
          trigger: ticker,
          start: `top bottom+=${height / 2}`,  // Adjust start based on ticker height
          end: `bottom top-=${height / 2}`,   // Adjust end based on ticker height
          scrub: true,
          markers: false  // Temporarily disable markers
        },
        modifiers: {
          x: gsap.utils.unitize(x => parseFloat(x) % loop.offsetWidth)
        }
      }
    );
  });
});

  // --- INITIALIZE ON LOAD ---
  window.addEventListener('load', () => {
    fadeInImages();
    new InstaMarqueeHandler(beholdURL);


    ScrollTrigger.refresh();
  });
})();
